import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

interface ResponseTypeData {
  responseType?: any;
}
@Injectable()
export class HttpService {
  constructor(public http: HttpClient) {}
  getToken() {
    return `Bearer ${localStorage.getItem('token')}`;
  }

  private getTargetHeaders() {
    return {
      'Content-Type': 'application/json',
      Authorization: this.getToken(),
    };
  }

  $request(options) {
    return new Promise((resolve, reject) => {
      fetch(options.url, {
        method: options.method,
        body: JSON.stringify(options.data),
        headers: Object.assign(
          {
            'content-type': 'application/json',
            Authorization: this.getToken(),
          },
          options.headers
        ),
      })
        .then((data) => {
          data.json().then((response) => {
            resolve(response);
          });
        })
        .catch((error) => reject(error));
    });
  }

  $httpGet(url, headers: any = {}) {
    const httpOptions = {
      headers: new HttpHeaders(
        Object.assign(
          {
            'Content-Type': 'application/json',
            Authorization: this.getToken(),
          },
          headers
        )
      ),
    };
    const responseTypeData: ResponseTypeData = {};
    if (headers.responseType) {
      responseTypeData.responseType = headers.responseType;
    }
    return this.http.get(url, { ...httpOptions, ...responseTypeData });
  }

  $httpPost(url, data, headers: any = {}) {
    const httpOptions = {
      headers: new HttpHeaders(Object.assign(this.getTargetHeaders(), headers)),
    };
    const responseTypeData: ResponseTypeData = {};
    if (headers.responseType) {
      responseTypeData.responseType = headers.responseType;
    }
    return this.http.post(url, data, { ...httpOptions, ...responseTypeData });
  }

  $httpDelete(url, data, headers: any = {}) {
    const httpOptions = {
      headers: new HttpHeaders(this.getTargetHeaders()),
      body: data,
    };
    const responseTypeData: ResponseTypeData = {};
    if (headers.responseType) {
      responseTypeData.responseType = headers.responseType;
    }
    return this.http.delete(url, { ...httpOptions, ...responseTypeData });
  }

  $httpPut(url, data, headers: any = {}) {
    const httpOptions = {
      headers: new HttpHeaders(Object.assign(this.getTargetHeaders(), headers)),
    };
    const responseTypeData: ResponseTypeData = {};
    if (headers.responseType) {
      responseTypeData.responseType = headers.responseType;
    }
    return this.http.put(url, data, { ...httpOptions, ...responseTypeData });
  }
}
